import GroupMasterTable from "./GroupMasterTable";
import { ToastContainer, toast } from 'react-toastify';
import { Cookies } from 'react-cookie';
import { useEffect, useState,useRef } from "react";
import { ExportData } from "../../Exports/Export";
import * as XLSX from 'xlsx';
import Loader from "../../Layout/Loader";
import { ClearSession } from '../../Common/Common'
import { useNavigate } from 'react-router-dom';
import Footer from "../../Layout/FooterComponent";
const cookies = new Cookies();

const GroupMasterForm = () => {
    const [edit, setEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false)
    const [tableData, setTableData] = useState([])
    const [ColoredRow, setColoredRow] = useState('');
    const [SessionClear, SetSessionClear] = useState(false);
    const navigate = useNavigate()

    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterList, setFilterList] = useState([]);
    const [filterData, setFilterData] = useState({
        SearchText: "",
        StartValue: "1",
        SearchFieldValue: "",
    })
    const [formData, setFormData] = useState({
        UserGroupID:'',
        GroupName: '',
        Active: true
    });
    const inputRefs = useRef([]);

    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode')
    const Source = 'web';

    const getGroupMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Source: 'web',
            Type: 'S',
            PageIndex: `${PageIndex}`
        }
        setLoading(true)
        await fetch('/api/User/ShowUserGroupMaster', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }
        ).then(async (response) => {
            let res = await response.json();
            if (res.status === 'SUCCESS') {
                setTableData(res)
                setLoading(false)
            }
            else if (res.message === "EXPIRED") {
                navigate("/login")
                SetSessionClear(true);
            }
            else if (res.message !== "") {
                toast.error(res.message, {
                    
                })
                setLoading(false)
            }
        }).catch((err) => {
            toast.error(err.message, {
             
            })
            setLoading(false)
        })
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevformdata) => ({ ...prevformdata, [name]: value }));
    }

    const handleClear = () => {
        setFormData({
            GroupName: '',
            UserGroupID:'',
            Active: true,
        })
        filterData.SearchText = ''
        setColoredRow(null)
        setEdit(false)
        getGroupMasterData()
    }

    const handleSubmit = async () => {
        let data = {
            ...formData, Token, LoginUserCode, Source
        }
        setIsLoading(true)
        await fetch('/api/User/InsertUpdateUserGroupMaster', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async(response) => {
            let res = await response.json();
            if (res.status === "SUCCESS") {
                setIsLoading(false);
                toast.success(res.message, {
                   
                })
                handleClear();
                setIsLoading(false)
                setEdit(false);
             
                getGroupMasterData();
            }
            else if (res.message === "EXPIRED") {
                navigate("/login")
                SetSessionClear(true);
            }
            else if (res.message !=="") {
                setIsLoading(false)
                toast.error(res.message, {
                  
                })
                inputRefs.current['txtGroupName'].focus()
                
            }
        }).catch((err) => {
            setIsLoading(false)
             toast.error(err, {
                   
                })
        })
    };

    const handleEditData = async (id) => {
        const data = {
            Token: await cookies.get('token'),
            LoginUserCode: await cookies.get('loginUserCode'),
            Source: 'web',
            UserGroupID: id
        }
        await fetch(`/api/User/EditUserGroupMaster`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            await setEdit(true)
            let res = await response.json()
            if (res.status === 'SUCCESS') {
                setColoredRow(id)
                await setFormData({ ...formData, UserGroupID: id, GroupName: res.groupName, Active: res.active });
            }
            else if (res.message === "EXPIRED") {
                navigate("/login")
                SetSessionClear(true);
            }
            else if (res.message !=="") {
                toast.error(res.message, {
                    position: 'top-center'
                })
            }
        }).catch((err) => {
            toast.success(err, {
                position: 'top-center'
            })
        })
    }

    const getSearchingList = async () => {
        let data = {
            Token, LoginUserCode, PageName: 'UserGroupMaster'
        }
        await fetch('/api/DashboardController/BindSearchingColumnList', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json()
            if (res.status === 'SUCCESS') {
                let list = res.getSearchingList
                setFilterData({ ...filterData, SearchFieldValue: list[0].searchingValue })
                setFilterList(res.getSearchingList)
            }
            else if (res.message === "EXPIRED") {
                SetSessionClear(true);
            }
            else if (res.message !== "") {
                toast.error(res.message, {
                   
                })
            }
            
        }).catch((err) => {
            toast.error(err.message, {
               
            })
        })
    };

    const handleChange1 = (event, value) => {
        getGroupMasterData(value);
    };

    const downloadExcel = (records) => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet([
            [records.hSrNo, records.hGroupName,
            records.hActive, records.hCreatedBy, records.hCreatedDate, records.hCreatedByIPAddress, records.hModifiedBy, records.hModifiedDate, records.hModifiedByIPAddress]
            ,
            ...records.getData.map((records) => [records.srNo, records.groupName, 
            records.active, records.createdBy, records.createdDate, records.createdByIPAddress, records.modifiedBy, records.modifiedDate, records.modifiedByIPAddress
            ]),
        ]);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveExcelFile(excelBuffer, 'GroupMaster.xlsx');
    };

    const saveExcelFile = (buffer, fileName) => {
        const data = new Blob([buffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const handleDownloadExcel = async () => {
        const apiUrl = `/api/User/ShowUserGroupMaster`;
        const requestBody = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Type: 'E',
            PageIndex: '1'
        }
        const requestHeaders = {
            'Content-Type': 'application/json',
        };
        const records = await ExportData(apiUrl, requestBody, requestHeaders);
        if (records) {
            downloadExcel(records);
        }
    };

    
    useEffect(() => {
        getGroupMasterData()
        getSearchingList()
        inputRefs.current['txtGroupName'].focus()
    }, [])

    return (
        <>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{'Group Master'}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                        <div className="fields">
                                            <label className="form-label">Group Name <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtGroupName'] =ref )}
                                                type="text"
                                                className="form-control"
                                                placeholder="Group Name"
                                                autoComplete="off"
                                                maxLength='30'
                                                id='txtGroupName'
                                                name='GroupName'
                                                value={formData.GroupName}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['chkActive'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                ref={ref => (inputRefs.current['chkActive'] = ref)}
                                                className="form-check-input"
                                                type="checkbox"
                                                id="activeCheckbox"
                                                name='Active'
                                                checked={formData.Active}
                                                onChange={(e) => setFormData({ ...formData, Active: e.target.checked })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmit()
                                                    };
                                                }}

                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-12">
                                        <div className="lms-new-button text-center">
                                            {edit ? (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update & Save
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <GroupMasterTable loading={loading} handleReset={handleClear} ColoredRow={ColoredRow} setColoredRow={setColoredRow} handleChange={handleChange1} currentPageNo={currentPageNo} filterList={filterList} filterData={filterData} setFilterData={setFilterData} tableData={tableData} getGroupMasterData={getGroupMasterData} handleEditData={handleEditData} />
            <ToastContainer theme='colored' />
           
            {SessionClear ? <ClearSession /> : <></>}
            <Footer/>
        </>
    )
}
export default GroupMasterForm